import(/* webpackMode: "eager" */ "/vercel/path0/apps/traeger/app/template.tsx");
